import { useDboAbilities } from 'features/db-optimization/hooks/useDboAbilities';

import { DboSidebarV1 } from './DboSidebarV1';
import { DboSidebarV2 } from './DboSidebarV2/DboSidebarV2';

export const DboSidebar = () => {
  const { isDboV2Enabled } = useDboAbilities();

  return isDboV2Enabled ? <DboSidebarV2 /> : <DboSidebarV1 />;
};
